import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { selectApp } from 'apps/employer-experience-v2/app.selectors';

export const selectInvoices = createSelector(
  selectApp,
  get('employerPayrollReports.invoices'),
);
